// three.js environments

export const data = [
  {
    id: 'apartment',
    name: 'Apartment',
  },
  {
    id: 'city',
    name: 'City',
  },
  {
    id: 'dawn',
    name: 'Dawn',
  },
  {
    id: 'forest',
    name: 'Forest',
  },
  {
    id: 'lobby',
    name: 'Lobby',
  },
  {
    id: 'park',
    name: 'Park',
  },
  {
    id: 'studio',
    name: 'Studio',
  },
  {
    id: 'sunset',
    name: 'Sunset',
  },
  {
    id: 'warehouse',
    name: 'Warehouse',
  },
];
